// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import updateLoadParameter from "@adl/App/Handlers/CustomQuote/UpdateLoadParameters";
import { xSearchFieldStyle } from "@adl/App/SharedStyle/searchFieldStyle";
import { CustomAppState } from "@adl/App/Store/Reducers";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import * as React from "react";
import { useState } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: CustomAppState) => {
    return {
        query: state.xMyCustomQuotes.getCustomQuotesParameter.search,
    };
};

const mapDispatchToProps = {
    updateLoadParameter,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface MyListsSearchBoxStyles {
    search?: TextFieldProps;
}

export const searchBoxStyles: MyListsSearchBoxStyles = {
    search: {
        ...xSearchFieldStyle.input,
    },
};

const styles = searchBoxStyles;

const MyCustomQuotesSearchBox = ({ updateLoadParameter, query }: Props) => {
    const [queryState, setQueryState] = useState(query);
    const [searchBoxTimeOut, SetSearchBoxTimeOut] = useState();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (typeof searchBoxTimeOut === "number") {
            clearTimeout(searchBoxTimeOut);
        }
        const query = event.currentTarget.value;
        setQueryState(event.currentTarget.value);
        SetSearchBoxTimeOut(
            setTimeout(() => {
                updateLoadParameter({ search: query });
            }, 250) as any,
        );
    };

    return (
        <TextField
            data-test-selector="myCustomQuotesByName"
            placeholder={translate("Search Quotes")}
            {...styles.search}
            value={queryState}
            onChange={handleChange}
        ></TextField>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(MyCustomQuotesSearchBox),
    definition: {
        group: "Custom Quotes" as any,
        displayName: "Search Box",
        allowedContexts: ["CustomQuotesPage" as any],
    },
};

export default widgetModule;
